module.exports = __webpack_public_path__ + "img/productHome5.86203b85.png";